/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { getPayloadObject, getTelemetryAttributes, ITelemetryContent, TelemetryConstant } from '@msdyn365-commerce-modules/utilities';

import React, { useState } from 'react';

export interface ICheckoutCartLineDeliveryDateProps {
    className?: string;
    isDisabled?: boolean;
    minRangeValue?: string;
    maxRangeValue?: string;
    validationErrorForRange?: string;
    fallbackPattern?: string;
    ariaLabel?: string;
    telemetryContent?: ITelemetryContent;
    disclaimerText?: string;
    heading?: string;
    checkBoxLabel?: string;
    onChangeMinValue?: void;
    id?: string;
}

const CheckoutCartLineDeliveryDate: React.FC<ICheckoutCartLineDeliveryDateProps> = ({
    className,
    isDisabled,
    fallbackPattern,
    ariaLabel,
    telemetryContent,
    onChangeMinValue,
    checkBoxLabel,
    disclaimerText,
    heading
}) => {
    const [selectedDate, setSelectedDate] = useState('');
    const allowedDates = ['2024-12-10', '2024-12-15', '2024-12-20'];
    const [isDateEnabled, setIsDateEnabled] = useState(true);

    const handleDateChange = (event: React.FocusEvent<HTMLInputElement>) => {
        const selectedValue = event.target.value;
        // Check if the selected date is allowed
        if (allowedDates.includes(selectedValue)) {
            setSelectedDate(selectedValue);
        } else {
            // Optionally, you can show a message or handle the disallowed date in some way
            console.warn('Selected date is not allowed.');
        }
    };

    const handleCheckboxChange = () => {
        setIsDateEnabled(!isDateEnabled);
    };

    const payLoad = getPayloadObject('click', telemetryContent!, TelemetryConstant.DeliveryOptions);
    const attributes = getTelemetryAttributes(telemetryContent!, payLoad);

    return (
        <div>
            <div>
                <input
                    className='ms-checkout-delivery-options__date-checkbox'
                    type='checkbox'
                    aria-label={ariaLabel}
                    name='requestDeliveryDate'
                    checked={isDateEnabled}
                    value={checkBoxLabel}
                    onChange={handleCheckboxChange}
                />
                <span>{checkBoxLabel}</span>
            </div>
            <span>{disclaimerText}</span>
            <span>{heading}</span>
            <input
                className='ms-checkout-delivery-options__date'
                type='date'
                name='dateInput'
                value={selectedDate}
                onChange={handleDateChange}
                // Optionally, you can set min and max attributes based on your allowed dates range
                min={allowedDates[0]}
                max={allowedDates[allowedDates.length - 1]}
                pattern={fallbackPattern}
                {...attributes}
                disabled={isDisabled}
            />
        </div>
    );
};

export default CheckoutCartLineDeliveryDate;
